import { createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  itemRoot: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.SPACING.MEDIUM,
    width: '100%',
    height: '70px',
    minHeight: '70px',
    borderTop: `1px solid ${theme.colors['palette-transparent']}`,
    borderBottom: `1px solid ${theme.colors['palette-transparent']}`,
    '&:hover': {
      backgroundColor: theme.colors['color-background-page'],
      borderColor: theme.colors['color-border-surface']
    },
    '&:hover button': {
      opacity: 1
    }
  },
  newItem: {
    backgroundColor: theme.colors['palette-blue-light-400']
  },
  itemStatusIconContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    minWidth: '30px'
  },
  itemMainInfoWrap: {
    display: 'flex',
    height: '70px',
    maxWidth: '280px',
    paddingLeft: theme.SPACING.MEDIUM,
    paddingTop: '16px',
    marginRight: theme.SPACING.MEDIUM
  },
  itemMainInfo: {
    width: '280px',
    display: 'flex',
    flexDirection: 'column'
  },
  itemFileName: {
    width: '280px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  itemActionWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '100%',
    minWidth: '120px',
    paddingTop: '12px',
    paddingLeft: theme.SPACING.MEDIUM
  },
  subText: {
    fontSize: '12px'
  },
  subTextFailed: {
    color: theme.colors['color-text-error']
  },
  subTextInProgress: {
    color: theme.colors['palette-gold']
  },
  subTextInQueued: {
    color: theme.colors['palette-blue']
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25px',
    height: '25px',
    borderRadius: '12.5px'
  },
  statusIcon: {
    fontSize: '1.25em',
    color: theme.colors['color-text-inverse']
  },
  queuedArrowIcon: {
    fontSize: '1.8em',
    color: theme.colors['palette-blue']
  },
  progressIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progressIcon: {
    fontSize: '1.8em',
    color: theme.colors['palette-gold']
  },
  progressArrowIcon: {
    position: 'absolute',
    fontSize: '1.7em',
    color: theme.colors['palette-gold']
  },
  successIcon: {
    fontSize: '2em',
    color: theme.colors['color-text-success']
  },
  cancelledIcon: {
    fontSize: '2em',
    color: theme.colors['palette-grey-dark-200']
  },
  statusErrorIcon: {
    fontSize: '2em',
    color: theme.colors['color-text-error']
  },
  dismissItemBtn: {
    opacity: 0,
    position: 'absolute',
    top: 5,
    right: 5,
    '&:hover': {
      backgroundColor: theme.colors['palette-grey-light-200']
    }
  },
  downloadLink: {
    visibility: 'hidden',
    width: 0,
    height: 0
  },
  timestamp: {
    color: theme.colors['palette-grey-dark-100']
  },
  btnLoadingSpinner: {
    marginLeft: '4px'
  },
  customTitleRoot: {
    height: theme.SPACING.FIELD_HEIGHT
  },
  customTitleDate: {
    fontSize: '12px',
    color: theme.colors['palette-grey-dark-100']
  }
}));
export default useStyles;